export const getHospedajesColumns = (coordinadores = [], edificios = []) => [
  {
    id: 'estado',
    label: 'Estado',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Activo', label: 'Activo' },
      { value: 'Inactivo', label: 'Inactivo' },
    ]
  },
/*   {
    id: 'edificioDisplay',
    label: 'Portafolio',
    type: 'text',
    sortable: false,
    required: false,
    hidden: true // Campo oculto para mostrar en tabla
  }, */
  {
    id: 'edificio',
    label: 'Portafolio',
    type: 'select',
    sortable: true,
    required: true,
    options: edificios
  },
  {
    id: 'nombrePropiedad',
    label: 'Nombre de Activo',
    type: 'text',
    sortable: true,
    required: true
  },
  {
    id: 'tipo',
    label: 'Tipo',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'vertical', label: 'Vertical' },
      { value: 'horizontal', label: 'Horizontal' },
    ]
  },
  {
    id: 'coordinadorDisplay',
    label: 'Coordinador',
    type: 'text',
    sortable: false,
    required: false,
    hidden: true // Campo oculto para mostrar en tabla
  },
  {
    id: 'coordinador',
    label: 'Coordinador',
    type: 'select',
    sortable: true,
    required: true,
    options: coordinadores
  },
  {
    id: 'gestionLenceria',
    label: 'Gestión de Lencería',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Autonoma', label: 'Autónoma' },
      { value: 'Central', label: 'Central' },
      { value: 'No aplica', label: 'No aplica' },
    ]
  },
  {
    id: 'gestionAseo',
    label: 'Gestión de Aseo',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'Camarera Propietario', label: 'Camarera Propietario' },
      { value: 'camarera pagada por el propietario', label: 'Camarera pagada por el propietario' },
      { value: 'Directa', label: 'Directa' },
      { value: 'No aplica', label: 'No aplica' },
    ]
  },

  {
    id: 'tipoRenta',
    label: 'Tipo de Renta',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'renta corta', label: 'Renta corta' },
      { value: 'mensual', label: 'Mensual' },
      { value: 'comercializable', label: 'Comercializable' },
      { value: 'casa', label: 'Casa' },
    ]
  },

  {
    id: 'numeroCamas',
    label: 'Número de Camas',
    type: 'number',
    sortable: true,
    required: true,
    min: 1
  },
  {
    id: 'numeroHabitaciones',
    label: 'Número de Habitaciones',
    type: 'number',
    sortable: true,
    required: true,
    min: 1
  },
  {
    id: 'tipoHabitacion',
    label: 'Tipo de Habitación',
    type: 'select',
    sortable: true,
    required: true,
    options: [
      { value: 'private_room', label: 'Habitación privada' },
      { value: 'entire_home', label: 'Casa completa' },
    ]
  },
  {
    id: 'opciones',
    label: 'Opciones',
    width: '10%',
    actions: [
      {
        key: 'manageCamas',
        icon: 'Bed',
        tooltip: 'Gestionar camas',
        className: 'text-purple-600 dark:text-purple-400 hover:text-purple-700 dark:hover:text-purple-300 hover:bg-purple-100 dark:hover:bg-purple-900',
      },
      {
        key: 'manageBanos',
        icon: 'Bath',
        tooltip: 'Gestionar baños',
        className: 'text-teal-600 dark:text-teal-400 hover:text-teal-700 dark:hover:text-teal-300 hover:bg-teal-100 dark:hover:bg-teal-900',
      },
      {
        key: 'edit',
        icon: 'Edit',
        tooltip: 'Editar hospedaje',
        className: 'text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900',
      },
      {
        key: 'delete',
        icon: 'Trash',
        tooltip: 'Eliminar hospedaje',
        className: 'text-red-600 dark:text-red-400 hover:text-red-700 dark:hover:text-red-300 hover:bg-red-100 dark:hover:bg-red-900',
      },
    ],
  },
];

// Columnas estáticas para cuando aún no se han cargado los datos
export const hospedajesColumns = getHospedajesColumns([], []);

export const columnsExcel = [
  { id: 'nombrePropiedad', label: 'Nombre de Activo' },
  { id: 'tipo', label: 'Tipo' },
  { id: 'gestionLenceria', label: 'Gestión de Lencería' },
  { id: 'gestionAseo', label: 'Gestión de Aseo' },
  { id: 'coordinadorDisplay', label: 'Coordinador' },
  { id: 'tipoRenta', label: 'Tipo de Renta' },
  { id: 'edificioDisplay', label: 'Edificio' },
  { id: 'numeroCamas', label: 'Número de Camas' },
  { id: 'numeroHabitaciones', label: 'Número de Habitaciones' },
  { id: 'tipoHabitacion', label: 'Tipo de Habitación' },
  { id: 'estado', label: 'Estado' },
];
